<template>
  <v-dialog v-model="visible" lazy width="600">
    <v-card>
      <v-container class="px-2 pt-2 pb-3" fluid>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="quantity"
              clearable
              type="number"
              label="Indica la cantidad que deseas asignar a los QMIs seleccionados"
              append-outer-icon="save"
              :hint="hint"
              @click:append-outer="updateQuantityOfItems"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState, mapActions } = createNamespacedHelpers(
  "classifier"
);

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    visible: false,
    quantity: 1,
  }),
  methods: {
    ...mapActions(["changeQuantityOfSelectedItems"]),
    ...mapMutations(["setItems"]),
    /**
     * Do not take in consideration the incorrect items and move the correct items
     * to the selected classification.
     */
    updateQuantityOfItems() {
      /* Remove the "incorrect" ones */
      this.setItems(
        this.items.map((item) => {
          if (item.correct) return item;
          return { ...item, correct: null };
        })
      );
      /* Classify the items */
      this.changeQuantityOfSelectedItems(this.quantity);
      /* Close the dialog */
      this.visible = false;
      /* Reset the quantity value */
      this.quantity = 1;
    },
  },
  watch: {
    value() {
      this.visible = this.value;
    },
    visible() {
      this.$emit("input", this.visible);
    },
  },
  computed: {
    ...mapState(["items"]),
    hint() {
      return `Solo a los QMIs seleccionados se les asignara la cantidad especificada`;
    },
  },
};
</script>